import { useCallback } from "react";

import { type RecoilState, useRecoilState } from "recoil";

export const useTags = (
    tagsState: RecoilState<readonly string[]>,
): {
    tagsList: readonly string[];
    addTag: (tag: string) => void;
    removeTag: (tag: string) => void;
    addTagsList: (list: readonly string[]) => void;
} => {
    const [tagsList, setTagsList] = useRecoilState(tagsState);

    const addTag = useCallback(
        (tag: string) => {
            setTagsList((tags) => [...tags, tag]);
        },
        [setTagsList],
    );

    const removeTag = useCallback(
        (tag: string) => {
            setTagsList((tags) => tags.filter((tagItem) => tagItem !== tag));
        },
        [setTagsList],
    );

    const addTagsList = useCallback(
        (list: readonly string[]) => {
            setTagsList(() => list);
        },
        [setTagsList],
    );

    return { tagsList, addTag, removeTag, addTagsList };
};
